import { Grid } from "@mui/material";
import PageHeader from "../../components/UI/Headers/PageHeader/PageHeader";
import Strings from "../../resources/Strings";
import classes from "../Validations/ValidationsPage.module.css";
import Icons from "../../resources/icons/Icons";
import ValidationsForm from "../../components/UI/Forms/Wizard Forms/AddForms/ValidationsForm";

const ValidationsPage = () => {
  return (
    <div className={classes.allocationsPage}>
      <Grid container spacing={4} className={classes.allocationsContainer}>
        <Grid xs={12} item className={classes.item}>
          <PageHeader
            icon={Icons.ALLOCATIONS2}
            pageTitle={Strings.TITLES.VALIDATIONS_PAGE}
            buttonText={Strings.PARKING_ALLOCATION}
            //validRole={gmtUser?.role?.hierarchy <= ROLES_HIERARCHY.COLLABORATOR}
            //handleModalOpen={handleModalOpen}
          />
        </Grid>
      </Grid>
      <ValidationsForm />
    </div>
  )
}

export default ValidationsPage;